import { Modal, Carousel } from "bootstrap/dist/js/bootstrap.esm.min.js";
import "./swiper";
import "./extended-cards";

window.addEventListener("DOMContentLoaded", (event) => {
  window.Carousel = Carousel;
  window.Modal = Modal;

  if (window.innerWidth > 992) {
    // Hover navbar
    var mainNavMenu = document.querySelector("#menu-primary-navigation");
    mainNavMenu.querySelectorAll(".nav-item").forEach(function (everyitem) {
      everyitem.addEventListener("mouseover", function (e) {
        let el_link = this.querySelector("a[data-bs-toggle]");

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.classList.add("show");
          nextEl.classList.add("show");
        }
      });
      everyitem.addEventListener("mouseleave", function (e) {
        let el_link = this.querySelector("a[data-bs-toggle]");

        if (el_link != null) {
          let nextEl = el_link.nextElementSibling;
          el_link.classList.remove("show");
          nextEl.classList.remove("show");
        }
      });
    });
  }
});
